import axios from '@/http.js';
import qs from 'qs';

export const font_upload_url = '/api/font/upload/fonts';
export default {
    getFontList(params) {
        return axios({
            method: 'get',
            url: 'api/font/list',
            params,
            paramsSerializer: params => {
                //indices——默认为 a[0]=b&a[1]=c&a[2]=d
                return qs.stringify(params, {indices: false});
            },
        })
    },
    getProjectFonts(params) {
        return axios({
            method: 'get',
            url: 'api/font/projectFontQuery',
            params,
            paramsSerializer: params => {
                return qs.stringify(params, {indices: false});
            },
        })
    },
    addFont(data) {
        const url = `/api/font/save`;
        return axios.post(url, data);
    },
    parseAndSaveFont(data) {
        const url = '/api/font/parseAndSaveFont';
        return axios.post(url, data, {
            headers: {
                projectId: data.projectId || ''
            }
        });
    },
    parseFont (data) {
        const url = '/api/font/parseFont';
        return axios.post(url, data, {
            headers: {
                projectId: data.projectId || ''
            }
        })
    },
    addFontByProject(data) {
        const url = `/api/font/projectSaveFont`;
        return axios.post(url, data,{
            headers: {
                projectId: data.projectId
            }
        });
    },
    addFontByAdmin(data) {
        const url = `/api/font/sysAdminSaveFont`;
        return axios.post(url, data);
    },
    updateFont(fonts) {
        const url = `/api/font/classify`;
        return axios.put(url, fonts);
    },
    updateFontCover(dataList) {
        const url = `api/font/updateFontCover`;
        return axios.put(url, dataList, {});
    },
    delFont(ids) {
        const url = `/api/font`;
        return axios.delete(url, {
            data: ids
        });
    },
    getMakerList() {
        const url = `/api/font/makerList`;
        return axios.get(url);
    },
    getTypeList() {
        const url = `/api/font/typeList`;
        return axios.get(url);
    },
    delProjectFont(projectId, fontIds) {
        const url = '/api/font/deleteProjectFont';
        return axios.delete(url, {
            data: {projectId, fontIds}
        });
    },
    getFontsByProjectId(projectId, nameList) {
        const url = `/api/font/listForProject`;
        return axios({
            method: 'get',
            url: url,
            headers: {
                projectId: projectId
            },
            params: {projectId, names: nameList},
            paramsSerializer: params => {
                return qs.stringify(params, {indices: false});
            },
        })
    },
    setProjectFont(fontIds, projectId, overwrite = false) {
        const url = `/api/font/setProjectFont`;
        return axios.post(url, {fontIds, projectId, overwrite});
    },
    uploadFonts(files, progressCallback) {
        let formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('files', files[i], files[i].name);
        }
        return axios.post(font_upload_url, formData, {
            onUploadProgress: progressEvent => {
                var complete = (progressEvent.loaded / progressEvent.total * 100 | 0);
                progressCallback && progressCallback(complete);
            }
        });
    },
    getFontListByNames(projectId, nameList) {
        const url = '/api/font/listByNames';
        return axios({
            method: 'get',
            url: url,
            params: {names: nameList, projectId},
            paramsSerializer: params => {
                return qs.stringify(params, {indices: false});
            },
        })
    },
    addFontName(data) {
        const url = '/api/font/addMainName';
        return axios.post(url, data);
    },
    updateFontAlias(data) {
        const url = `/api/font/editAlias`;
        return axios.put(url, data);
    },
    updateFontUrl(data, projectId = ''){
        const url = `api/font/updateUrl`;
        return axios.put(url, data, {
            headers: {
                projectId
            }
        });
    },
    getRecommendFonts (params) {
        return axios({
            method: 'get',
            url: 'api/font/recommend',
            params,
            paramsSerializer: params => {
                return qs.stringify(params, { indices: false });
            },
        })
    }
}



